module.exports = __webpack_public_path__ + "img/12-数据为空.2b57688c.png";